import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HeaderTemplateData } from '../dialog-data.interface';

@Component({
    selector: 'dialog6-template',
    templateUrl: 'dialog6-template.html',
    styleUrls: ['dialog6-template.scss']
})
export class Dialog6Template implements OnInit {
    header:HeaderTemplateData;
    constructor(
        public dialogRef: MatDialogRef<Dialog6Template>,
        @Inject(MAT_DIALOG_DATA) private data: HeaderTemplateData,

    ) {
        if(data){
            this.header = data;
        }
    }

    ngOnInit() {
    }

   
}
